import { render, staticRenderFns } from "./BrainIcon.vue?vue&type=template&id=7c423937&scoped=true"
import script from "./BrainIcon.vue?vue&type=script&lang=js"
export * from "./BrainIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c423937",
  null
  
)

export default component.exports